var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":"view-project__view"}},[(_vm.botid)?_c('BotFlow',{attrs:{"botid":_vm.botid,"config":{review: true}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }